import React from 'react';
import { useAuth } from '@es-tools/shared';
import { getBrandConfig } from '../brand-config';
import '../styles/NavBar.css';

interface NavBarProps {
  showBackToPortal?: boolean;
  showBackToHome?: boolean;
  showUserInfo?: boolean;
}

const NavBar: React.FC<NavBarProps> = ({ 
  showBackToPortal = false, 
  showBackToHome = true,
  showUserInfo = true
}) => {
  const { user } = useAuth();
  const brandConfig = getBrandConfig();

  const handleBackToHome = () => {
    window.location.href = '/';
  };

  const handleBackToPortal = () => {
    window.open('https://automations.easystreetbrands.com', '_blank', 'noopener,noreferrer');
  };

  return (
    <nav className="navbar" style={{ '--brand-color': brandConfig.primaryColor } as React.CSSProperties}>
      <div className="navbar-content">
        <div className="navbar-left">
          <div className="brand-info">
            <img 
              src={brandConfig.logo} 
              alt={`${brandConfig.name} Logo`} 
              className="navbar-logo"
            />
            <span className="brand-name">{brandConfig.name}</span>
          </div>
        </div>

        <div className="navbar-center">
          {showBackToHome && (
            <button onClick={handleBackToHome} className="nav-link">
              ← Back to {brandConfig.name} Home
            </button>
          )}
          {showBackToPortal && (
            <button onClick={handleBackToPortal} className="nav-link">
              ← Back to Automation Portal
            </button>
          )}
        </div>

        <div className="navbar-right">
          {showUserInfo && user && (
            <div className="user-info">
              {user.picture ? (
                <img src={user.picture} alt={user.name} className="navbar-avatar" />
              ) : (
                <div className="navbar-avatar-placeholder">
                  {user.name?.charAt(0).toUpperCase()}
                </div>
              )}
              <span className="user-name">{user.name}</span>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
